import { createAnatomy as o } from "../../anatomy/dist/index.mjs";
import { createScope as i } from "../../dom-query/dist/index.mjs";
import { createProps as a } from "../../types/dist/index.mjs";
var t = o("progress").parts(
  "root",
  "label",
  "track",
  "range",
  "valueText",
  "view",
  "circle",
  "circleTrack",
  "circleRange"
);
t.build();
i({
  getRootId: (r) => {
    var e;
    return ((e = r.ids) == null ? void 0 : e.root) ?? `progress-${r.id}`;
  },
  getTrackId: (r) => {
    var e;
    return ((e = r.ids) == null ? void 0 : e.track) ?? `progress-${r.id}-track`;
  },
  getLabelId: (r) => {
    var e;
    return ((e = r.ids) == null ? void 0 : e.label) ?? `progress-${r.id}-label`;
  },
  getCircleId: (r) => {
    var e;
    return ((e = r.ids) == null ? void 0 : e.circle) ?? `progress-${r.id}-circle`;
  }
});
a()([
  "dir",
  "getRootNode",
  "id",
  "ids",
  "max",
  "min",
  "orientation",
  "translations",
  "value"
]);
export {
  t as anatomy
};
